module.exports = __webpack_public_path__ + "static/media/ic_add_new_user.94f8632d.svg";